import React from "react";
import MainText from "../components/Apply/MainText";
import MainTitle from "../components/Apply/MainTitle";
import { useTheme } from "@mui/styles";
import { Box, useMediaQuery } from "@mui/material";
import { useCourses } from "../context/CourseContext";
import BackButton from "../components/ApplyForm/BackButton";
import Modalities from "../components/IntroductoryCourse/Modalities";
import { useLocation } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";

const useStyles = (theme) => ({
  span: { fontWeight: "bold" },
  cardsContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { md: "center" },
    mt: { md: "20px" },
    mb: { xs: "70px", md: "251px" },
  },
  introContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonContainer: {
    width: { xs: "594px", md: "900px", lg: "920px", xl: "1200px" },
    mt: { lg: "-10rem", xl: "-10rem", xs: "-4rem", md: "-10rem" },
    mb: { lg: "10rem", xl: "10rem", xs: "4rem", md: "8rem" },
    display: "flex",
    justifyContent: {
      xs: "center",
      sm: "center",
      md: "flex-start",
      lg: "flex-start",
      xl: "flex-start",
    },
  },
  normal: { fontWeight: "normal" },
});

const ApplyIntro = () => {
  const { atrCourse, introCourses } = useCourses();
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const { title, description, img, subtitle } = useTranslation(
    pathname,
    "ApplyIntro"
  );

  return (
    <>
      <MainTitle
        title={title}
        subtitle={
          <>
            <span style={classes.span}>{description[0]}</span>
            {description[1]}
            {!isMobile && (
              <>
                <br></br>
                <br></br>
                {description[2]}
              </>
            )}
          </>
        }
        img={img}
        width={{ xs: "287px", md: "400px" }}
      />

      <MainText
        text={
          <>
            <span style={classes.normal}>{subtitle[0]}</span>
            {subtitle[1]}
          </>
        }
        mt={{ xs: "-113px", md: "-50px", lg: "-50px", xl: "-20px" }}
        scroll={true}
      />

      <Box sx={classes.introContainer}>
        <Box sx={classes.cardsContainer}>
          <Modalities
            atrCourse={atrCourse}
            introCourses={introCourses}
            showTitle={false}
          />
        </Box>
        <Box sx={classes.buttonContainer}>
          <BackButton />
        </Box>
      </Box>
    </>
  );
};

export default ApplyIntro;
